import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const Container = styled.div`
  min-height: 60vh;
  width: 100%;
  display: grid;
  place-items: center;
  align-content: center;
  gap: 12px;
  padding: 32px;
  text-align: center;
`;

export const Spinner = styled.div`
  width: 42px;
  height: 42px;
  border-radius: 999px;
  border: 3px solid hsl(var(--foreground) / 0.12);
  border-top-color: hsl(var(--primary));
  animation: ${spin} 0.9s linear infinite;
`;

export const Text = styled.strong`
  font-size: 20px;
  font-weight: 800;
  color: hsl(var(--foreground));
`;

export const SubText = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: hsl(var(--foreground) / 0.65);
`;
